import { Component } from '@angular/core';

import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-resulth-local-connect-saiba-mais-dialog',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, MatIconModule],
  templateUrl: './resulth-local-connect-saiba-mais-dialog.component.html',
  styleUrls: ['./resulth-local-connect-saiba-mais-dialog.component.css'],
})
export class ResulthLocalConnectSaibaMaisDialogComponent {
  constructor(public dialogRef: MatDialogRef<ResulthLocalConnectSaibaMaisDialogComponent>) {}

  fechar(): void {
    this.dialogRef.close();
  }
}
